<script>
import PhoneTokenField from '@phoenix/mixins/components/form/fields/PhoneTokenField';
import { useField } from '@phoenix/composables/field';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import TextField from '@maison/components/form/fields/TextField.vue';
import fieldMixin from '@maison/mixins/fieldMixin';

export default {
  components: {
    PhxsgButton,
    TextField,
  },

  mixins: [fieldMixin, PhoneTokenField],

  setup(props) {
    return useField(props);
  },
};
</script>

<template>
  <text-field v-model="value" :should-validate="false" />
  <div class="field-helper-text">
    <PhxsgButton variant="link" @click.prevent.stop="onSendTokenBtnClick">
      {{ $t('Form.resendPhoneToken') }}
    </PhxsgButton>
  </div>
</template>
